import { getAxiosClientWithToken } from './index';
import { KisokuTemplateLogRequest } from 'app/slice/kisokuTemplateLogSlice';

export const kisokuTemplateLogClick = (request: KisokuTemplateLogRequest) => {
    const { filename } = request;
    const restClient = getAxiosClientWithToken();
    return restClient.post(`/company/kisoku-template-log`, { filename });
};
